// vendor
import { SetupContext, ref } from "@vue/composition-api";
// project
import { useFavourites } from "@/hooks/useFavourites";
import { useTags } from "@/hooks/useTags";
import * as AppModal from "@/AppModal";

type Config = {
	context:SetupContext;
};

export const useTagManager = (c:Config) => {

	const dropTarget = ref<string|null>();

	const {
		sortedTags,
		editTag,
		tagItem,
		deleteTag,
		createTag,
	} = useTags();

	const {
		isFavourite,
		addFavourite,
		removeFavourite
	} = useFavourites();

	const onCreate = async() => {
		AppModal.editText({
			title:"New Tag",
			value:"New Tag",
			validator(v){
				return v.length > 2;
			},
		},  (v:string) => {
			createTag(v);
		});
	};

	const openTagContext = (e:any, id:string) => {
		const tag = sortedTags.value.find(t => t._id === id);
		if(!tag){ return; }


		const options:any[] = [];

		if(!isFavourite(id)){
			options.push({
				name:"Add to Favourites",
				icon:"mdi.star",
				fn:() => addFavourite(id, "tag"),
				order:0,
			});
		}
		else {
			options.push({
				name:"Remove From Favourites",
				icon:"mdi.star-outline",
				fn:() => removeFavourite(id),
				order:0,
			});
		}

		options.push({
			name:"Rename",
			icon:"mdi.pencil",
			fn(){
				AppModal.editText({
					title:"Rename",
					value:tag.name,
					validator(v){
						return v !== tag.name && v.length > 2;
					}
				}, (v:string) => {
					editTag(tag._id, { name:v });
				});
			},
			order:1,
		});

		options.push({
			name:"Set Color",
			icon:"mdi.format-color-fill",
			fn(){
				AppModal.editColor({
					title:"Set Tag Color",
					value:tag.color,
					validator(v){
						return tag.color !== v; 
					},
				}, (v:string) => {
					editTag(tag._id, { color:v });
				});
			},
			order:1,
		});

		options.push({
			name:"Delete",
			icon:"mdi.trash-can",
			fn(){

				AppModal.confirm({
					title:"Delete Tag",
					variant:"danger",
					description:"This is irreversible. Are you sure?",
					okText:"I Understand",
				}, () => {
					deleteTag(tag._id);
				});
			},
			order:2,
		});

		AppModal.context(e, options);
	};

	const handleTagDrop = (e:any, tag:string) => {
		const dataString = e.dataTransfer.getData("tagTarget");
		if(dataString){
			const data:{
				type:"asset"|"study";
				item:string;
			} = JSON.parse(dataString);

			if(data.type && data.item){
				tagItem(tag, data.item, data.type);
			}
		}
		dropTarget.value = null;
	};
	

	return {
		sortedTags,
		dropTarget,
		openTagContext,
		handleTagDrop,
		createTag:onCreate,
	};

};